export const KEYPOINT_STAGE = {
    SET_KEYPOINT: "STAGE.SET_KEYPOINT",
    UPDATE_KEYPOINT_HOVERING: "STAGE.UPDATE_KEYPOINT.HOVERING",
    UPDATE_KEYPOINT_CLICKED: "STAGE.UPDATE_KEYPOINT.CLICKED"
};
